import { ImpactAssessment } from './impact-assessment';
import { ItemIdModel } from '../filter-model/item-id-model';
import { UserProfile } from '../user';
import { ImpactAssessmentT6ListDto } from './impact-assessmentT6-list';

export class ImpactOutcome {
    id: number;
    impactAssessmentId: number;
    impactOutcomeId: number;
    impactOutcomeParentId: number;

    constructor() {
        this.id = 0;
        this.impactAssessmentId = 0;
        this.impactOutcomeId = 0;
        this.impactOutcomeParentId = 0;
    }
}

export class ImpactRatingModel {
  impactAssessment: ImpactAssessment;
  jurisdictionList: ItemIdModel[];
  userAccessToken: UserProfile;
  constructor() {
    this.impactAssessment = new ImpactAssessment();
    this.jurisdictionList = [];
    this.userAccessToken = new UserProfile();
  }
}
export class ImpactRatingModelT6 {
  impactAssessment: ImpactAssessmentT6ListDto;
  jurisdictionList: ItemIdModel[];
  userAccessToken: UserProfile;
  constructor() {
    this.impactAssessment = new ImpactAssessmentT6ListDto();
    this.jurisdictionList = [];
    this.userAccessToken = new UserProfile();
  }
}
export class ImpactOutcomeRatingInput {
  Id: number;
  Rating: number;

  constructor() {
      this.Id = 0;
      this.Rating = 0;
  }
}